import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import DOMPurify from "dompurify";
import ArrowButton from '../button-arrow';
import { acceptPrivacy } from '../../../actions/user';
import { connect } from "react-redux";
import { getPrivacyPolicy } from "../../../actions/content";

import './privacy-popup.css';

class PrivacyPopup extends Component {
  componentDidMount() {
    const { show, dispatch, popupActive } = this.props;

    if (show) {
      dispatch(getPrivacyPolicy());
    }

    this.setPopupMaxHeight();
    window.addEventListener('resize', this.setPopupMaxHeight);
    popupActive(true);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setPopupMaxHeight);
  }

  setPopupMaxHeight = () => {
    if (this.refs.popupBodyRef) {
      this.refs.popupBodyRef.style.setProperty('max-height', `${window.innerHeight / 2}px`);
    }
  }

  onConfirm() {
    const { dispatch } = this.props;

    dispatch(acceptPrivacy()).then(() => {
      try {
        dispatch({type: 'TOGGLE_PRIVACY_MODAL', payLoad: false});
      } catch(error) {
        // swallowed modal lib bug error
      }
    });
  }

  cancel(event) {
    event.preventDefault();
  }

  componentWillUnmount() {
    const { popupActive } = this.props;

    popupActive(false);
  }

  render() {
    const { content } = this.props;

    return (
      <div className="container-fluid">
        <Modal
          show={true}
          animation={false}
          container={this}
          aria-labelledby="contained-modal-title"
          backdropStyle={{ width: "100%" }}
        >
          <Modal.Header>
            <Modal.Title>Our Privacy Policy has been updated</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="popup-content"
              ref='popupBodyRef'
              dangerouslySetInnerHTML={ { __html: DOMPurify.sanitize(content) } }
            />
          </Modal.Body>
          <Modal.Footer>
            <ArrowButton color="red"
                         className="pull-right"
                         submit={false}
                         arrow={false}
                         onClick={() => this.onConfirm(true)}>Close</ArrowButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

PrivacyPopup.propTypes = {
  show: PropTypes.bool
};

PrivacyPopup.defaultProps = {
  show: false,
};

export default connect(state => ({
  content: state.privacyPolicy.content
}))(PrivacyPopup);



// WEBPACK FOOTER //
// ./src/components/common/privacy-policy/privacy-popup.jsx